module.exports = __webpack_public_path__ + "img/y_p3_x1.5359edc8.svg";